import { AggregateColumn } from './aggregateColumn';
import { ColumnTypeEnum } from './columnType';
import { DateFrequency } from './dateFrequency';
import { DateAddType, DateAddUnit, DatePartType, DateUnitType, FilterStatementOp, JoinOperator, JoinPattern, PeriodAddType, SortDirection, ToolEnumType } from './toolEnumTypes';
// separate from toolEnumTypes.ts in case someone leaves an enum in the original class in domain-base
// ie you leave aggColOperation in AggregateColumn.ts, this causes a circ ref if this map is in toolEnumTypes.ts
//		aggColOperation -> enumToolVariable -> toolEnumTypes
//		toolEnumTypes/toolEnumMap -> aggregateColOperation
export const ToolEnumTypesMap = new Map([
    [ToolEnumType.SortDirection, SortDirection],
    [ToolEnumType.AggregateColumnOperation, AggregateColumn.Operation],
    [ToolEnumType.DateFrequency, DateFrequency],
    [ToolEnumType.DateAddUnit, DateAddUnit],
    [ToolEnumType.DateAddType, DateAddType],
    [ToolEnumType.DateUnitType, DateUnitType],
    [ToolEnumType.DatePartType, DatePartType],
    [ToolEnumType.JoinOperator, JoinOperator],
    [ToolEnumType.JoinPattern, JoinPattern],
    [ToolEnumType.FilterStatementOp, FilterStatementOp],
    [ToolEnumType.PeriodAddType, PeriodAddType],
    // TODO: maybe this one should be removed
    [ToolEnumType.ColumnType, ColumnTypeEnum]
]);
//# sourceMappingURL=toolEnumTypesMap.js.map